var map = {
	"./bars.svg": 117,
	"./chevron-down.svg": 573,
	"./chevron-right.svg": 501,
	"./close.svg": 837,
	"./facebook.svg": 479,
	"./github.svg": 394,
	"./instagram.svg": 373,
	"./linkedin.svg": 430,
	"./mail.svg": 814,
	"./x.svg": 897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 669;